import { render, staticRenderFns } from "./PoliciesLightCommercial.vue?vue&type=template&id=bd121b0e&scoped=true&"
import script from "./PoliciesLightCommercial.vue?vue&type=script&lang=js&"
export * from "./PoliciesLightCommercial.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesLightCommercial.vue?vue&type=style&index=0&id=bd121b0e&scoped=true&lang=css&"
import style1 from "./PoliciesLightCommercial.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd121b0e",
  null
  
)

export default component.exports